export default function ContactSection() {
  return (
    <section id="contact" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            联系我们
          </h2>
          <div className="max-w-lg mx-auto">
            <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-mail-send-line text-2xl text-accent-500"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">投稿与合作</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                如果您有优质探花资源推荐、内容投稿或商务合作意向，欢迎通过以下方式联系我们。我们重视每一份来稿，期待与您共同打造更丰富的探花精选平台。
              </p>
              <a
                href="#contact"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-chat-3-line"></i>
                发起联系
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}